export default __webpack_public_path__ + "static/media/IconDesc_iron_new.256.11d406f6.png";